module.exports = __webpack_public_path__ + "static/media/dec-netverify-jumio.21c0b1b1.png";